export interface DimensionsState {
  gaDimensions: any
}

export const initialState = {
  gaDimensions: null,
}

export const dimensions = (
  state: DimensionsState = initialState,
  action: ReduxAction,
): DimensionsState => {
  switch (action.type) {
    case 'GET_ALL_GA_DIMENSIONS': {
      return {
        ...state,
        gaDimensions: { ...action.payload },
      }
    }
    default:
      return state
  }
}
